import IconInSquare from './IconInSquare'

export default IconInSquare
